const memberMemoryRecords = new Map();
const memberVolatileKeys = new Set();
const memberCloudCacheEnabled = memberId =>
    window.tbApplicationConfig?.memberReading?.enabled === true &&
    document.getElementById("fr-member-data")?.dataset.memberId === memberId;

window.memberDataStore = {
    load(memberId) {
        const key = `fr-member:${memberId}`;
        let value;
        if (memberVolatileKeys.has(key) && memberCloudCacheEnabled(memberId)) {
            value = memberMemoryRecords.get(key);
        } else {
            try {
                value = localStorage.getItem(key);
                memberMemoryRecords.set(key, value);
            } catch (error) {
                if (!memberCloudCacheEnabled(memberId)) throw error;
                value = memberMemoryRecords.get(key);
            }
        }

        if (!value) {
            return {
                posts: {}
            };
        }

        return JSON.parse(value);
    },

    save(memberId, data) {
        const key = `fr-member:${memberId}`;
        const value = JSON.stringify(data);
        memberMemoryRecords.set(key, value);
        try {
            localStorage.setItem(key, value);
            memberVolatileKeys.delete(key);
        } catch (error) {
            if (!memberCloudCacheEnabled(memberId)) throw error;
            memberVolatileKeys.add(key);
        }
    }
};
